import { useOverlays } from "contexts/OverlayContext";
import { CreateCoAAccountModal } from "./CoAAccountModal/CreateCoAAccountModal";

export const CreateCoAAccountModalContainer = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();

    const overlayInfo = getOverlayInfo<"createCoaAccount">("createCoaAccount");

    if (!overlayInfo?.data) {
        return null;
    }

    return (
        <CreateCoAAccountModal
            show={!overlayIsClosing}
            onHide={() => closeOverlay()}
            {...overlayInfo.data}
        />
    );
};
